'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVid = exports.setVisitor = exports.setLatestMessageSeen = exports.setLatestReadTimestamp = exports.setLatestMessage = exports.setAssignedAgentId = undefined;

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _KeyPaths = require('../../thread/constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setAssignedAgentId = exports.setAssignedAgentId = (0, _setIn2.default)(_KeyPaths.ASSIGNED_AGENT_ID);

var setLatestMessage = exports.setLatestMessage = (0, _setIn2.default)(_KeyPaths.LATEST_MESSAGE);

var setLatestReadTimestamp = exports.setLatestReadTimestamp = (0, _setIn2.default)(_KeyPaths.LATEST_READ_TIMESTAMP);

var setLatestMessageSeen = exports.setLatestMessageSeen = (0, _setIn2.default)(_KeyPaths.LATEST_MESSAGE_SEEN);

var setVisitor = exports.setVisitor = (0, _setIn2.default)(_KeyPaths.VISITOR);

var setVid = exports.setVid = (0, _setIn2.default)(_KeyPaths.VID);